import dayjs from 'dayjs';
import { ISelectOption } from '../interfaces';

export type THourFormat = '12' | '24';

/**
 * Generates time select options for a full day based on a configurable interval.
 *
 * @param textFormat - Display format for the option text.
 *   - '12' - 12-hour format (e.g. `1 PM`)
 *   - '24' - 24-hour format (e.g. `13:00`)
 * @param valueFormat - Format used for the option value.
 *   - '12' - 12-hour format
 *   - '24' - 24-hour format
 * @param incrementMinutes - Interval, in minutes, between each option.
 *   Defaults to '60' (hourly).
 *
 * @returns {ISelectOption[]}
 *
 */
export const getTimeslotsOfDay = (textFormat: THourFormat, valueFormat: THourFormat, incrementMinutes = 60):ISelectOption[] => {
  const startOfDay = dayjs().startOf('day');
  const minutesInDay = 24 * 60;
  const steps = minutesInDay / incrementMinutes;

  const formatMap = {
    12: 'h:mm A',
    24: 'HH:mm',
  };

  return Array.from({ length: steps + 1 }, (_, i) => {
    const time = startOfDay.add(i * incrementMinutes, 'minute');

    return {
      text: time.format(formatMap[textFormat]),
      value: time.format(formatMap[valueFormat]),
    };
  });
};
